module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Sauvegarder","b":"Annuler"},"en":{"a":"Save","b":"Cancel"}}')
  delete Component.options._Ctor
}
